import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import {
  DynamoDBDocumentClient,
  GetCommand,
  QueryCommand
} from "@aws-sdk/lib-dynamodb";
import { fetchAuthSession } from "aws-amplify/auth";

// env
const {
  REACT_APP_REGION,
  REACT_APP_JOB_REPORTS_TABLENAME,
} = process.env;

const queryTable = async ({ user_id, job_id }) => {

  // get credentials
  const { credentials } = await fetchAuthSession();
  const docClient = DynamoDBDocumentClient.from(
    new DynamoDBClient({
      region: REACT_APP_REGION,
      credentials: credentials,
    })
  );

  // build command
  const command = new QueryCommand({
    TableName: REACT_APP_JOB_REPORTS_TABLENAME,
    KeyConditionExpression: '#rn = :rn',
    ExpressionAttributeNames: {
      '#rn': 'resource_name',
    },
    ExpressionAttributeValues: {
      ':rn': `user:${user_id}:job:${job_id}`,
    },
  });

  const res = await docClient.send(command);
  return res.Items;
}

const handler = async ({ user_id, job_id }, { getState, rejectWithValue }) => {
  try {
    console.log('services.job.get.job.reports@handler', user_id, job_id);

    // get reports
    const reports = await queryTable({ user_id, job_id});
    console.log('services.job.get.job.reports@handler', 'reports', reports);

    return reports;

  } catch (error) {
    console.error('services.job.get.job.reports@handler', error);
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    reports: action.payload,
  };
}

const rejected = (state, action) => {
  return {
    ...state,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}